import { render } from "./butDel.vue?vue&type=template&id=119125f0"
import script from "./butDel.vue?vue&type=script&lang=js"
export * from "./butDel.vue?vue&type=script&lang=js"

import "./butDel.vue?vue&type=style&index=0&id=119125f0&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__